(function(){
  const dropdownButton = document.getElementById('dropdown-button')
  const dropdownRegion = document.getElementById('dropdown-region')
  // Button inside the region that can also close the menu, for keyboard navigation
  const dropdownRegionButton = document.getElementById('dropdown-region-close')

  function showMenu() {
    dropdownButton.classList.add('active')
    dropdownButton.setAttribute('aria-pressed', true)

    dropdownRegion.classList.add('active')
    dropdownRegion.setAttribute('aria-hidden', false)
  }

  function hideMenu() {
    dropdownButton.classList.remove('active')
    dropdownButton.setAttribute('aria-pressed', false)

    dropdownRegion.classList.remove('active')
    dropdownRegion.setAttribute('aria-hidden', true)
  }

  // Add event listeners
  dropdownButton.addEventListener('click', function() {
    if (this.classList.contains('active')) {
      hideMenu()
    } else {
      showMenu()
    }
  })

  dropdownRegionButton.addEventListener('click', function() {
    hideMenu()
  })

})();
